<template>
	<div>
		<MediaLibraryModal v-on:mediaInsert="insertPhoto($event)" v-on:hideMediaModal="hideMediaModal()" />
		<div id="editClient" class="container mt-3">
			<JuniperPageHeader back="/juniper/clients" :title="client ? client.name : ''" subtitle="Edit Client Business" />
			<!-- Heading - Client Name Logo Info and Map -->
			<div class="row mt-4 client-heading-section">
				<div class="col-md-6">
					<div class="client-heading mb-3">
						<div class="logo">
							<div class="logo-wrapper">
								<a role="button" @click="removeLogo()" v-if="client.logo" class="btn btn-danger btn-sm rounded-circle remove-logo"
									><font-awesome-icon :icon="['fas', 'trash']"
								/></a>
								<img
									v-if="client.logo"
									title="For logo use .png if posible"
									@click="showMediaModal()"
									class="cursor-pointer w-100"
									:src="client.logo"
									:alt="client.name"
								/>
								<button v-else class="btn" title="For logo use .png if posible" @click="showMediaModal()">+ Logo</button>
							</div>
						</div>
						<div class="client-name">
							<h2 class="m-0 p-0 me-3" data-bs-toggle="offcanvas" href="#offcanvasDev" role="button" aria-controls="offcanvasDev">{{ client.name }}</h2>
						</div>
					</div>
					<div class="client-details">
						<div class="mb-2">
							<b>Theme: </b> <span class="badge bg-primary">{{ client.theme }}</span>
						</div>
						<div class="mb-2"><b>Type: </b> {{ client.type }}</div>
						<div class="mb-2">
							<b>Staging URL: </b> {{ client.staging_url }}
							<a class="btn btn-secondary btn-sm ms-2" target="_blank" :href="client.staging_url"><font-awesome-icon :icon="['fas', 'external-link-alt']"/></a>
						</div>
					</div>
					<div>
						<router-link class="btn btn-primary me-2" :to="'/juniper/clients/edit/' + client.id + '/customizer'">
							<font-awesome-icon :icon="['fas', 'palette']" />
							Customizer
						</router-link>
					</div>
				</div>
				<div class="col-md-6">
					<GmapMap :center="center" :zoom="zoom" map-type-id="terrain" :disableDefaultUI="true" style="width: 100%; height: 250px">
						<GmapMarker :key="'client-marker'" :position="center" :draggable="false" />
					</GmapMap>
					<div class="juniper-mode juniper-staging-mode bg-info-lighter mt-3">
						<div>Here we can download full content for client <b>static</b> website, all files that is needed will be in <b>Zip</b> file.</div>
						<div class="juniper-mode-actions">
							<button @click="downloadStatic(backups[0].name)" class="btn btn-success ms-2"><font-awesome-icon :icon="['fas', 'file-csv']" /> Download files</button>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 mt-5">
					<h2>Backups</h2>
					<div class="border px-3 py-2 rounded-1" style="height: 225px;overflow-y: auto;">
						<div class="d-flex align-items-center flex-row mb-2 justify-content-between" v-for="(backup, i) in backups" :key="i">
							<div>{{ backup.time }}</div>
							<div>{{ backup.date }}</div>
							<div>{{ backup.size }}</div>
							<div>
								<button @click="downloadStatic(backup.name)" class="btn btn-primary ms-2">
									<font-awesome-icon :icon="['fas', 'download']" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- #Heading - Client Name Logo Info and Map -->
		</div>
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasDev" aria-labelledby="offcanvasDevLabel">
			<div class="offcanvas-header">
				<h5 class="offcanvas-title" id="offcanvasDevLabel">{{ client.name }}</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<div>
					<div class="form-group mb-3">
						<label for="status">Status</label>
						<select id="status" class="form-select" v-model="client.status">
							<option value="live">Live</option>
							<option value="preparing">Preparing</option>
							<option value="development">Development</option>
							<option value="abandoned">Abandoned</option>
							<option value="left">Left</option>
						</select>
					</div>

					<div class="form-group mb-3">
						<label for="type">Type</label>
						<select id="type" class="form-select" v-model="client.type">
							<option value="municipal">Municipal</option>
							<option value="business">Business</option>
							<option value="internal">Internal</option>
						</select>
					</div>

					<div class="form-group mb-3">
						<label for="">Last static generated</label>
						<input
							type="date"
							class="form-control"
							:value="formatDate(client.last_static_generated_at)"
							@input="client.last_static_generated_at = $event.target.value"
						/>
					</div>

					<div class="form-group mb-3">
						<label for="">Launched At</label>
						<input type="date" class="form-control" :value="formatDate(client.launched_at)" @input="client.launched_at = $event.target.value" />
					</div>
				</div>
				<div class="dropdown mt-3 d-none">
					<button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown">
						Dropdown button
					</button>
					<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
						<li><a class="dropdown-item" href="#">Action</a></li>
						<li><a class="dropdown-item" href="#">Another action</a></li>
						<li><a class="dropdown-item" href="#">Something else here</a></li>
					</ul>
				</div>
				<div>
					<button class="btn btn-primary" @click="updateClient()">Update</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap'
import { mapGetters, mapState } from 'vuex'
import juniperApi from '@/api/juniperApi'
// import restApi from '../../../api/index'
import MediaLibraryModal from '@/components/juniper/media/MediaLibraryModal'
// import ClientsSearch from '../../../components/clients/ClientsSearch.vue'
import juniperUserMixin from '@/mixins/juniperUserMixin'

export default {
	name: 'EditClient',
	data() {
		return {
			client: {},
			zoom: 12,
			center: { lat: 44.8228, lng: -87.366 },
			loadingBackups: false,
			backups: [] }
	},
	components: { MediaLibraryModal },
	computed: {
		...mapState(['authUser', 'tokenJuniper']),
		...mapGetters(['isAuth']),
		live() {
			return !this.client.staging
		} },

	mounted() {
		this.mediaModal = new Modal('#mediaLibraryModal')
	},

	created() {
		this.getClient()
	},
	methods: {
		// Get client
		getClient() {
			this.loading = true
			juniperApi
				.get('/clients/' + this.$route.params.id)
				.then(({ data }) => {
					this.client = data
					this.getBackups()
					this.getClientOptions()
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		insertPhoto(photoUrl) {
			this.client.logo = photoUrl
			this.updateLogo()
			this.mediaModal.hide()
		},

		// Show media library modal
		showMediaModal(e) {
			this.mediaElement = e
			this.mediaModal.show()
		},

		// Hide media library modal
		hideMediaModal() {
			this.mediaModal.hide()
		},

		updateLogo() {
			juniperApi
				.put('/clients/update/' + this.$route.params.id + '/logo', this.client)
				.then(({ data }) => {
					this.client = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		removeLogo() {
			this.client.logo = null
			this.updateLogo()
		},

		updateClient() {
			juniperApi
				.put('/clients/' + this.$route.params.id, this.client)
				.then(() => {
					//success
					this.$swal.fire({
						icon: 'success',
						title: 'Client updated successfully',
						timer: 2000 })
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		// Get client options
		getClientOptions() {
			this.loading = true
			juniperApi
				.post('/options/' + this.$route.params.id)
				.then(({ data }) => {
					this.clientOptions = data
					if (this.clientOptions.subscribable_terms) {
						if (this.clientOptions.subscribable_terms['App\\Models\\MeetingRepositoryCategory']) {
							this.meetingRepositoryCategoriesSubscribable = this.clientOptions.subscribable_terms['App\\Models\\MeetingRepositoryCategory']
						}
						if (this.clientOptions.subscribable_terms['App\\Models\\NewsNoticeCategory']) {
							this.newsNoticeCategoriesSubscribable = this.clientOptions.subscribable_terms['App\\Models\\NewsNoticeCategory']
						}
					}
					if (this.clientOptions.meeting_table_active_columns) {
						this.meetingTableColumnsActive = this.clientOptions.meeting_table_active_columns
					}
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},
		// Get client Backups
		getBackups() {
			this.loadingBackups = true
			juniperApi
				.post('/clients/' + this.$route.params.id + '/static/backups/100000')
				.then(({ data }) => {
					this.backups = data
					this.loadingBackups = false
				})
				.catch(error => {
					this.loadingBackups = false
					console.log(error)
				})
		},

		async downloadStatic(backupUrl) {
			let filename = backupUrl.split('/').pop()
			try {
				const response = await juniperApi.post(
					'/clients/' + this.$route.params.id + '/static/download',
					{
						url: backupUrl },
					{
						responseType: 'blob' }
				)
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', filename)
				document.body.appendChild(link)
				link.click()
				link.remove()
			} catch (error) {
				console.error('Error downloading:', error)
				alert('Error downloading static files. Please try again later.')
			}
		},
		formatDate(date) {
			if (!date) return ''
			const d = new Date(date)
			const year = d.getFullYear()
			const month = String(d.getMonth() + 1).padStart(2, '0') // Mesecevi indeksi su 0-11
			const day = String(d.getDate()).padStart(2, '0')
			return `${year}-${month}-${day}` // 'YYYY-MM-DD'
		} },

	watch: {
		clientOptions: function() {
			this.checkForErrors()
			this.checkForWarnings()
		} },
	mixins: [juniperUserMixin] }
</script>
<style scoped>
.juniper-mode {
	padding: 10px;
	display: flex;
	justify-content: space-between;
	align-items: start;
	border-radius: 10px;
}

.juniper-mode-actions {
	min-width: 170px;
}

.juniper-maintenance-mode {
	border-width: 5px;
	border-style: solid;
	border-color: transparent;
}

.juniper-maintenance-mode.on {
	border-width: 5px;
	border-style: solid;
	border-color: var(--bs-warning);
}

.website-status {
	height: 86px;
	border: 2px solid gray;
	padding: 10px;
	border-radius: 10px;
}

.client-heading {
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
}

.logo-wrapper {
	width: 100px;
	position: relative;
	margin-right: 15px;
}

.logo-wrapper .remove-logo {
	position: absolute;
	right: -14px;
	top: -12px;
}

.logo-wrapper button {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 80px;
	max-height: 80px;
	min-width: 80px;
	border: 1px solid #dedede;
	border-radius: 10px;
}

.logo-wrapper img {
	min-height: 80px;
	max-height: 80px;
	min-width: 80px;
	max-width: 160px;
	object-fit: contain;
	border-radius: 10px;
}
</style>
